import { render, staticRenderFns } from "./ActivityDetailsPopup.vue?vue&type=template&id=3d06a990&scoped=true"
import script from "./ActivityDetailsPopup.vue?vue&type=script&lang=js"
export * from "./ActivityDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetailsPopup.vue?vue&type=style&index=0&id=3d06a990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06a990",
  null
  
)

export default component.exports